import React, { useContext } from "react";
import { useUserAuth } from "../../context/UserAuthContext";
import setting from "../../assests/settings.png";
import styles from "../Profile/Profile.module.css";
import { useNavigate, useParams } from "react-router";
import Context from "../../context/Context";
import user from "../../assests/user.svg";
function ProfileHead({ setEditProfile, setSettings, settings }) {
  const { currentUser } = useUserAuth();

  return (
    <div>
      <div className={styles.prodivHome}>
        <img
          className={styles.propicHome}
          src={currentUser?.photoURL ? currentUser?.photoURL : user}
          alt=""
        />
        <div>
          <p className="text-large-medium mb-[12px]">
            {currentUser?.displayName}
          </p>
          <div className="w-[100%]" onClick={() => setEditProfile(true)}>
            <p className="text-regular text-[#0F6ABE] cursor-pointer">
              Edit Profile
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProfileHead;
